/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components */
import Component from '@ember/component';
import PageType from 'linced-app/enums/page-type';
import { service } from '@ember/service';
import Options from '@linc-technologies/linced-common/enums/options';
import Scopes from '@linc-technologies/linced-common/enums/scopes';
import { optionAlias } from '@linc-technologies/linced-common/utils/options';
import { alias } from '@ember/object/computed';

export default class SiteSetupTabs extends Component {
  // Attrs
  PageType = PageType;

  Scopes = Scopes;

  // Services
  @service
  features;

  @service
  options;

  @alias('features.linkedGoalsEnabled')
  linkedGoalsEnabled;

  // Check for linked goals enabled as the initial release of this feature is on available to schools
  // using the curriculum toolkit

  // Props
  // selected specifies the currently selected tab.
  selected = '';

  // postTemplatesEnabled checks whether the Post Templates Hero-Only option is
  // enabled for this school.
  @optionAlias(Options.HERO_POST_TEMPLATES_ENABLED)
  postTemplatesEnabled;

  // onChange provides a callback for when a tab has been clicked.
  onChange() {}
}
